import { Provider } from '@angular/core';
import { provideDateAdapter } from './date-adapter';
import { provideMatDateFormats } from './date-formats';
import { provideMatFormFieldDefaultOptions } from './default-options.config';
import { provideEnabledErrorStateMatcher } from './enabled-error-state-matcher';

export function provideMatConfig(): Provider[] {
  return [
    provideEnabledErrorStateMatcher(),
    provideMatDateFormats(),
    provideDateAdapter(),
    provideMatFormFieldDefaultOptions()
  ];
}
